<svelte:options customElement="clw-icon-back" />

<script lang="ts">
    export let fillColor = 'white';
</script>

<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M6 10L2 6M2 6L6 2M2 6L14 6"
        stroke={fillColor}
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
